import React, { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";

export default function Testimonials() {
  const reviews = [
    {
      stars: 5,
      text: "O locație superbă și o echipă extraordinară. Totul a fost perfect la nunta noastră! Recomandăm cu tot dragul Elysium Events pentru profesionalismul de care dau dovadă.",
      author: "Maria & Ionuț",
      type: "Nuntă"
    },
    {
      stars: 5,
      text: "Am organizat gala anuală a companiei noastre aici și am fost profund impresionați. De la sonorizare și lumini până la serviciul de catering, totul s-a ridicat la standarde internaționale de 5 stele.",
      author: "Andrei R., Tech Sibiu",
      type: "Eveniment Corporate"
    },
    {
      stars: 5,
      text: "Botezul fetiței noastre la Elysium a fost pur și simplu de basm. Decorurile personalizate în nuanțe calde de champagne și atenția personalului ne-au depășit complet așteptările.",
      author: "Elena & Cristian S.",
      type: "Botez"
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrev = () => {
    setActiveIndex((prev) => (prev === 0 ? reviews.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev === reviews.length - 1 ? 0 : prev + 1));
  };

  return (
    <section 
      id="testimoniale"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-[#121212] overflow-hidden relative"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <Quote className="text-[#D4AF37]/10 w-24 h-24 absolute top-0 left-10 -translate-y-8 -z-10 transform -scale-x-100" />
        
        {/* Header */}
        <div className="space-y-4 mb-16">
          <span className="text-xs font-semibold tracking-[0.3em] text-[#D4AF37] uppercase">
            OPINIILE CLIENȚILOR NOȘTRI
          </span>
          <h2 
            data-testid="testimonials-title"
            className="font-serif-lux text-3xl sm:text-5xl text-white font-medium tracking-tight"
          >
            Ce Spun Cei Care Ne-au Ales
          </h2>
        </div>

        {/* Carousel / Slider Container */}
        <div 
          data-testid="testimonial-slider"
          className="relative bg-black/30 border border-white/5 p-8 sm:p-12 backdrop-blur-md"
        >
          {/* Active Review */}
          <div className="space-y-6">
            {/* Stars */}
            <div className="flex justify-center space-x-1">
              {[...Array(reviews[activeIndex].stars)].map((_, i) => (
                <Star key={i} size={18} fill="#D4AF37" className="text-[#D4AF37]" />
              ))}
            </div>

            {/* Testimonial Text */}
            <p 
              data-testid="testimonial-text"
              className="text-base sm:text-xl text-[#F3E5D8] font-light italic leading-relaxed"
            >
              „{reviews[activeIndex].text}”
            </p>

            {/* Author */}
            <div className="pt-4">
              <h4 className="text-sm font-semibold tracking-widest text-white uppercase">
                {reviews[activeIndex].author}
              </h4>
              <span className="text-[10px] tracking-[0.2em] text-[#D4AF37] uppercase">
                {reviews[activeIndex].type}
              </span>
            </div>
          </div>

          {/* Carousel Arrows */}
          <div className="flex items-center justify-center space-x-4 mt-8">
            <button
              data-testid="testimonial-prev-btn"
              onClick={handlePrev}
              className="p-3 border border-white/10 hover:border-[#D4AF37] text-white hover:text-[#D4AF37] transition-all duration-300"
            >
              <ChevronLeft size={16} />
            </button>
            <button
              data-testid="testimonial-next-btn"
              onClick={handleNext}
              className="p-3 border border-white/10 hover:border-[#D4AF37] text-white hover:text-[#D4AF37] transition-all duration-300"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>

      </div>
    </section>
  );
}
